import React from "react";
import { Link } from "react-router-dom";
import styles from "./Footer.module.css";
import logo from "../../assets/logo.png";
import { FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import whatsappIcon from "../../assets/whatsapp.png";

const Footer = () => {
  const phoneNumber = "919650817621";
const message = "Hello! I am interested in learning more about Saraswati Vidya Mandir. Could you please provide me with more information? Thank you!  ";
  
  return (
    <footer className={styles.footer}>

      <div className={styles.container}>

        {/* 🏫 LOGO + ABOUT */}
        <div className={styles.column}>
          <img src={logo} alt="School Logo" className={styles.logo} />
          <p>
            Saraswati Vidya Mandir provides quality education with discipline,
            values, and holistic development for every student.
          </p>
        </div>

        {/* 🔗 QUICK LINKS */}
        <div className={styles.column}>
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/curriculum">Curriculum</Link></li>
            <li><Link to="/gallery">Gallery</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        {/* 📍 CONTACT */}
        <div className={styles.column}>
          <h3>Contact Us</h3>
     <p>
  <FaPhoneAlt className={styles.icon} /> +91 9650817621
</p>

<p>
  <FaMapMarkerAlt className={styles.icon} /> Gali Number 3, Village Chhalera & Sadarpur, Chhalera Bangar, Sector 44, Noida, Uttar Pradesh 201303
</p>
          {/* <p>📧 info@svmschool.com</p> */}

          {/* 🌐 SOCIAL ICONS */}
         <div className={styles.social}>
  <a href="https://www.facebook.com/saraswatividyamandirschool" target="_blank" rel="noopener noreferrer">
    <FaFacebookF />
  </a>

  <a href="https://www.instagram.com/saraswatividyamandir_school" target="_blank" rel="noopener noreferrer">
    <FaInstagram />
  </a>

</div>
        </div>

      </div>

      {/* 🔻 Bottom */}
      <div className={styles.bottom}>
   <p>
  © 2026 Saraswati Vidya Mandir • All Rights Reserved. Designed and Developed by{" "}
  <a
    href="https://digimarqtechnology.com"
    target="_blank"
    rel="noopener noreferrer"
  >
    Digimarq Technology Pvt. Ltd.
  </a>
</p>
      </div>

<a
  href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`}
  className={styles.whatsappFloat}
  target="_blank"
  rel="noopener noreferrer"
>
  <img src={whatsappIcon} alt="WhatsApp" />
</a>

    </footer>
  );
};

export default Footer;